module.exports = __webpack_public_path__ + "img/vip-discount.19106dcb.png";